const getters = {
  needSync: state => state.permission.needSync,
  token: state => state.permission.token,
  menus: state => state.permission.menus
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js